/**
 * Practice status is tri-state: unreviewed, confirmed, or hidden. Clicking an
 * unreviewed clinic confirms it; later clicks toggle confirmed and hidden.
 */
export function nextPracticeRuling(isPractice) {
  return isPractice !== true;
}

export function practiceLabel(isPractice) {
  if (isPractice === true) return 'Practice';
  if (isPractice === false) return 'Hidden';
  return 'Unreviewed';
}
